module.exports = __webpack_public_path__ + "img/20190801163926057.8dc3de96.png";